// @ts-nocheck
import { PageHeader } from '@ant-design/pro-components';
import { Divider, Input, } from 'antd';
import { Content } from 'antd/es/layout/layout';

import React from 'react';
import { ApplicationsResponseModel } from '@uniquegood/realworld-admin-interface';

import { Link, useLocation } from 'react-router-dom';
import DefaultLayout from '@src/components/DefaultLayout';

import { useChannelController } from '@src/hooks/channel/use-channel-controller';
import { ChannelTable } from './channel-table';

const { Search } = Input;

export default function StudioChannel() {
    const controller = useChannelController();
    React.useEffect(() => {

    }, []);

    return (
        <DefaultLayout>
            <PageHeader title="채널 관리" subTitle="" style={{ margin: '16px 20px 0px 20px' }} />
            <Content style={{ padding: '0 24px', margin: '0px 20px' }}>
                <div className="px-4 py-6 sm:px-0">
                    <ChannelTable
                        channels={controller.channels}
                        isLoading={controller.isLoading}
                        searchInput={controller.searchInput}
                        onSearchChange={controller.setSearchInput}
                        onSearch={controller.handleSearch}
                        selectedPlan={controller.selectedPlan}
                        onPlanChange={controller.setSelectedPlan}
                        currentPage={controller.currentPage}
                        totalPages={controller.totalPages}
                        onPageChange={controller.goToPage}
                        onNextPage={controller.handleNextPage}
                        onPrevPage={controller.handlePrevPage}
                        onChannelClick={controller.openDetailModal}
                        onApplyPlan={controller.openApplyPlanSearchModal}
                    />
                </div>
            </Content>
        </DefaultLayout>
    );
}
